import { useQuery } from '@tanstack/react-query';
import { fetchCarrierList } from '../data-provider/carrier-list';
import type { GetCarrierListRequestParams } from '../data-provider/carrier-list/api';

export const useGetCarrierList = (params: GetCarrierListRequestParams) => {
  return useQuery({
    queryKey: ['shipment-carrier-list', params.customerKey],
    queryFn: () => fetchCarrierList(params),
    enabled: !!params.customerKey,
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
